import React, { useEffect,useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import { Grid, Chip, Paper, InputBase, IconButton, FormControl, Stack, MenuItem, Box, Select, Typography, Collapse,Tabs,Tab} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { AppButton } from '../../resources/styling';
import { colors } from '../../resources/theme/colors';
import Cookies from 'js-cookie';
import { getAppUrls } from '../../utils/config';
import {
  AppContainer,
  MainContentContainer,
  BodyContainer,
  WhiteContainer,
  GroupTableStyle,
  TableStyle,
  AdminTabs,
} from '../../resources/styling/appStyle';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  TableSortLabel,
} from '@mui/material';

import groupService from '../../services/api/matGroupService';
import { Edit, Delete, ExpandMore, ExpandLess } from '@mui/icons-material'; // Icons for actions 
const { WELLBEING_APP_URL,INSIGHTS_APP_URL,HOME_APP_URL,EI_APP_URL } = getAppUrls();
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  bgcolor: 'background.paper',
  borderRadius: 1,  
  boxShadow: 24,
  p: 3,
};


const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const { mandy, pictonBlue } = colors;

function MatSubscriptionList() {

const [value, setValue] = React.useState(0);
const handleTabChange = (event, newValue) => {
  setValue(newValue);
};
const navigate = useHistory();
const [sort, setSort] = React.useState('');

const handleChange = (event) => {
    setSort(event.target.value);
};

const [open, setOpen] = React.useState(false);
const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);

    

  const [adminDashboardInfo, setAdminDashboardInfo] = useState({});
  const [surveys, setSurveys] = React.useState([])
  const [mysurvey, setMysurvey] = React.useState([])
  const [filteredSurveys, setFilteredSurveys] = React.useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [order, setOrder] = useState('asc'); // 'asc' or 'desc'
  const [orderBy, setOrderBy] = useState('id'); // Default column to sort by
  const [expandedRows, setExpandedRows] = useState([]); // Track expanded rows
  const [searchQuery, setSearchQuery] = useState(''); // Search query state

  useEffect(() => {
    setLoading(true)
    groupService.getAllMatGroups()      
      .then((response) => {
        if (response.success) 
        {
          setAdminDashboardInfo(response);      
          console.log(response)    
          loadData();
          setLoading(false);          
        }
      })
      .catch(err => {})
      .finally(() => setLoading(false));
      const loadData = async () => {
        try {
          await new Promise((resolve) => setTimeout(resolve, 200000));        
        } catch (err) {       
        } finally {}
      };
            
  }, []);  
  

  /* Welbee Grid Properties and function starts*/
  const handleSchoolDetails = (id) => {
    // Handle edit action
    console.log('Edit item with ID:', id);
    Cookies.set('SchoolDetailId', id, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    navigate.push('/edit-subscription-school')
    // You can open a modal or navigate to an edit page here      
  };

   /* Welbee Grid Properties and function starts*/
   const handleMatDetails = (id) => {
    // Handle edit action
    console.log('Edit item with ID:', id);
    Cookies.set('MatDetailId', id, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    navigate.push('/edit-subscription')
    // You can open a modal or navigate to an edit page here
  };

  const handleEDUIntellMATclick = (MATId,SchoolId) => { 
     Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days   
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId');
    Cookies.set('Type', 'MAT', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    var MatURL= EI_APP_URL; //"https://ei.welbee.co.uk/login";
    window.open(MatURL);
  };
  const handleEDUIntellSchoolclick = (MATId,SchoolId) => {
    Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId');
    Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    var SchoolURL=EI_APP_URL; //"https://ei.welbee.co.uk/login";
    window.open(SchoolURL);
  };

  const handleSchoolInsightsclick = (MATId,SchoolId) => {
    Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days   
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId');
    Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    var SchoolURL=INSIGHTS_APP_URL; //"https://insights.welbee.co.uk/login";
    window.open(SchoolURL);
  };
  
  const handleMatInsightsclick = (MATId,SchoolId) => {   
    Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId');
    Cookies.set('Type', 'MAT', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days      
    var SchoolURL=INSIGHTS_APP_URL; //"https://insights.welbee.co.uk/login";
    window.open(SchoolURL);    
  };

  const handleSchoolWelbeingclick = (MATId,SchoolId) => {
    Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days       
    Cookies.set('MatToken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
    Cookies.set('schooltoken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
    Cookies.remove('MatToken');
    Cookies.remove('schooltoken');     
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId');       
    Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days   
    var SchoolURL=WELLBEING_APP_URL; //"https://s.wellbeing.welbee.co.uk/login";
    window.open(SchoolURL);   
  };
  
  const handleMatWelbeingclick = (MATId,SchoolId,MATToken) => {
    Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days          
    Cookies.set('MatToken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
    Cookies.set('schooltoken', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
    Cookies.remove('MatToken');
    Cookies.remove('schooltoken');     
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId');          
    Cookies.set('Type', 'MAT', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days    
    Cookies.set('token', MATToken, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days    
    var MATURL=WELLBEING_APP_URL; //"https://s.wellbeing.welbee.co.uk/login";
    window.open(MATURL); 
  };

  const handleSchoolHomeclick = (MATId,SchoolId) => {
    Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days   
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId');
    Cookies.set('Type', 'School', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    // var SchoolURL="https://s.peoplemanagement.welbee.co.uk/login";
    var SchoolURL=HOME_APP_URL; //"https://s.home.welbee.co.uk/login";
    window.open(SchoolURL);    
  };
  
  const handleMatHomeclick = (MATId,SchoolId) => {
    Cookies.set('Type', '', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('MATId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days  
    Cookies.set('SchoolId', 0, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days     
    Cookies.remove('Type');
    Cookies.remove('MATId');
    Cookies.remove('SchoolId'); 
    Cookies.set('Type', 'MAT', { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('MATId', MATId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days
    Cookies.set('SchoolId', SchoolId, { domain: '.welbee.co.uk',expires: 1 }); // Expires in 1 days   
    // var MATURL="https://s.peoplemanagement.welbee.co.uk/login";
    var MATURL=HOME_APP_URL; //"https://s.home.welbee.co.uk/login";
    window.open(MATURL);   
  };
  
      
  const handleDelete = (id) => {
    // Handle delete action
    console.log('Delete item with ID:', id);
    // Update the data state by removing the item
    //setData(data.filter((item) => item.id !== id));
  };

  const handleWelbeeChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleWelbeeChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleWelbeeSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleExpand = (Id) => {
    // Toggle expanded rows
    if (expandedRows.includes(Id)) {
      setExpandedRows(expandedRows.filter((rowId) => rowId !== Id));
    } else {
      setExpandedRows([...expandedRows, Id]);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value); // Update search query
    setPage(0); // Reset to the first page when searching
  };

  // Filter data based on search query
  const filteredData = adminDashboardInfo.data?.filter(x => !x.IsTestAccount && !x.IsArchived).filter((row) =>
    Object.values(row).some(
      (value) =>
        typeof value === 'string' &&
        value.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const sortedWelbeeData = (filteredData || []).slice().sort((a, b) => {
    if (a[orderBy] < b[orderBy]) {
      return order === 'asc' ? -1 : 1;
    }
    if (a[orderBy] > b[orderBy]) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  });
/* Welbee Grid Properties and function ends*/

/* Welbee Grid PData For Test Groups and their Schools*/
const filteredTestData = adminDashboardInfo.data?.filter(x => x.IsTestAccount && !x.IsArchived).filter((row) =>
  Object.values(row).some(
    (value) =>
      typeof value === 'string' &&
      value.toLowerCase().includes(searchQuery.toLowerCase())
  )
);

const sortedTestWelbeeData = (filteredTestData || []).slice().sort((a, b) => {
  if (a[orderBy] < b[orderBy]) {
    return order === 'asc' ? -1 : 1;
  }
  if (a[orderBy] > b[orderBy]) {
    return order === 'asc' ? 1 : -1;
  }
  return 0;
});
/* Welbee Grid PData For Test Groups and their Schools ends here */

  if (error) {
    return (
      <Typography variant="h6" color="error" align="center">
        {error}
      </Typography>
    );
  }

  return (
    <AppContainer>                                   
         {/* Group Listing */}
         <AdminTabs style={{ marginTop: '20px' }}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label='admin-tabs'
              >
                <Tab label='Live Groups' />
                <Tab label='Test Groups' />
              </Tabs>
            </Box>
            {loading===true? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <CircularProgress />
                </div>  
            ) : (
            <div>
              <CustomTabPanel value={value} index={0}>
                <Grid container mt={2}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <GroupTableStyle>                    
                            <Paper elevation={0} variant='outlined'>
                                <TableContainer>
                                    <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                            active={orderBy === 'Name'}
                                            direction={orderBy === 'Name' ? order : 'asc'}
                                            onClick={() => handleWelbeeSort('Name')}
                                            >
                                            Group Name
                                        </TableSortLabel>
                                        </TableCell>                                       
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'Products'}
                                                direction={orderBy === 'Products' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('Products')}
                                                >
                                                Products
                                            </TableSortLabel>
                                        </TableCell>                                      
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'StartDate'}
                                                direction={orderBy === 'StartDate' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('StartDate')}
                                                >
                                                Start Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'EndDate'}
                                                direction={orderBy === 'EndDate' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('EndDate')}
                                                >
                                                End Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'SubscriptionCost'}
                                                direction={orderBy === 'SubscriptionCost' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('SubscriptionCost')}
                                                >
                                                Subscription Cost
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            Action
                                        </TableCell>
                                        </TableRow>
                                    </TableHead>        
                                    <TableBody>
                                        {(sortedWelbeeData || [])
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => (
                                            <React.Fragment key={row.Id}>
                                            <TableRow>
                                                <TableCell>
                                                <IconButton onClick={() => handleExpand(row.Id)} disableRipple sx={{padding: '0px !important'}}>
                                                    {expandedRows.includes(row.Id) ? <ExpandLess /> : <ExpandMore />}
                                                </IconButton>
                                                </TableCell>
                                                <TableCell>{row.Name}</TableCell>                                            
                                                <TableCell>                                               
                                                    <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={0.5}>
                                                        {row.MatSchoolProductsList && (row.MatSchoolProductsList || []).length > 0 ? (
                                                            row.MatSchoolProductsList.filter((item, index, self) => 
                                                                self.findIndex((i) => i.Product === item.Product) === index
                                                            ).map((marProducts) => (
                                                                <React.Fragment key={marProducts.id}>                                                               
                                                                    {marProducts.Product === 1 && (
                                                                        // <Chip label="Main App & Toolkit" className='staff-chip' size='small'/>
                                                                        <AppButton  label="Main App & Toolkit" onClick={() => handleMatWelbeingclick(marProducts.MatId,marProducts.SchoolId,row.GroupDirectors[0].UserId)} className='staff-chip' size='small'>Main App & Toolkit</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 2 && (
                                                                        // <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                                        <AppButton  label="Student Insight" onClick={() => handleMatInsightsclick(marProducts.MatId,marProducts.SchoolId)} className='parent-chip' size='small'>Student Insight</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 3 && (
                                                                        // <Chip label="Parents Insights" className='insight-chip' size='small'/>
                                                                        <AppButton  label="Parents Insights" onClick={() => handleMatInsightsclick(marProducts.MatId,marProducts.SchoolId)} className='insight-chip' size='small'>Parents Insights</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 4 && (
                                                                        // <Chip label="Staff Insights" className='student-chip' size='small'/>
                                                                        <AppButton  label="Staff Insights" onClick={() => handleMatInsightsclick(marProducts.MatId,marProducts.SchoolId)} className='student-chip' size='small'>Staff Insights</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 5 && (
                                                                        // <Chip label="Edu Intelligence" className='staff-chip' size='small'/>
                                                                        <AppButton  label="Edu Intelligence" onClick={() => handleEDUIntellMATclick(marProducts.MatId,marProducts.SchoolId)} className='edu-chip' size='small'>Edu Intelligence</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 6 && (
                                                                        <Chip label="Pulse" className='lparent-chip' size='small'/>
                                                                    )}
                                                                </React.Fragment>
                                                            ))
                                                        ) : (
                                                            <Chip label="No products available." className='learning-chip' size='small'/>
                                                        )}
                                                    </Stack>
                                                </TableCell>                                               
                                                <TableCell>{row.MatSubscription==null?formatDate(row.GroupDirectors[0]?.MatGroup?.Schools[0]?.SchoolSubscription?.StartDate):formatDate(row.MatSubscription.StartDate)}</TableCell>
                                                <TableCell>{row.MatSubscription==null?formatDate(row.GroupDirectors[0]?.MatGroup?.Schools[0]?.SchoolSubscription?.EndDate):formatDate(row.MatSubscription.EndDate)}</TableCell>                                                
                                                <TableCell>£{(parseInt(row.MatSubscription==null?0:row.MatSubscription.Year1Cost) + parseInt(row.MatSubscription==null?0:row.MatSubscription.Year2Cost) + 
                                                parseInt(row.MatSubscription==null?0:row.MatSubscription.Year3Cost))+((parseInt(row.MatSubscription==null?0:row.MatSubscription.Year1Cost) + 
                                                parseInt(row.MatSubscription==null?0:row.MatSubscription.Year2Cost) + parseInt(row.MatSubscription==null?0:row.MatSubscription.Year3Cost))*
                                                (parseInt(row.MatSubscription==null?0:row.MatSubscription.VatPercentApplied)/100))}</TableCell>
                                                <TableCell> 
                                                    <Stack direction="row" spacing={0.5}>                                                    
                                                    <AppButton  onClick={() => handleMatDetails(row.Id) } color={pictonBlue}>Renew</AppButton>                                                    
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                    <Collapse in={expandedRows.includes(row.Id)} timeout="auto" unmountOnExit>
                                                    <Box margin={1}>
                                                    <Typography variant="h6" gutterBottom component="div">
                                                        Schools
                                                    </Typography>
                                                    <TableStyle>
                                                        <Table size="small">
                                                            <TableHead>
                                                            <TableRow>
                                                                <TableCell>School Name</TableCell>                                                              
                                                                <TableCell>Products</TableCell>                                                                
                                                                <TableCell>Start Date</TableCell>
                                                                <TableCell>End Date</TableCell>
                                                                <TableCell>Subscription Cost</TableCell>
                                                                <TableCell>Action</TableCell>
                                                            </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                            {row.GroupDirectors[0]?.MatGroup?.Schools.map((detail) => (
                                                                <TableRow key={detail.Id}>
                                                                    <TableCell>{detail.Name}</TableCell>                                                                    
                                                                    <TableCell>
                                                                        <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={0.5}>
                                                                        {detail.schoolProductsList && detail.schoolProductsList.length > 0 ? (
                                                                            detail.schoolProductsList.filter((item, index, self) => 
                                                                            self.findIndex((i) => i.Product === item.Product) === index
                                                                            ).map((schoolProds) => (
                                                                                <React.Fragment key={schoolProds.id}>                                                                      
                                                                                {schoolProds.Product === 1 && (
                                                                                    // <Chip label="Main App & Toolkit" className='staff-chip' size='small'/>
                                                                                    <AppButton  label="Main App & Toolkit" onClick={() => handleSchoolWelbeingclick(schoolProds.MatId,schoolProds.SchoolId)} className='staff-chip' size='small'>Main App & Toolkit</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 2 && (
                                                                                    // <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                                                    <AppButton  label="Student Insight" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='parent-chip' size='small'>Student Insight</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 3 && (
                                                                                    // <Chip label="Parents Insights" className='insight-chip' size='small'/>
                                                                                    <AppButton  label="Parents Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='insight-chip' size='small'>Parents Insights</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 4 && (
                                                                                    // <Chip label="Staff Insights" className='student-chip' size='small'/>
                                                                                    <AppButton  label="Staff Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='student-chip' size='small'>Staff Insights</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 5 && (
                                                                                    // <Chip label="Edu Intelligence" className='learning-chip' size='small'/>
                                                                                    <AppButton  label="Edu Intelligence" onClick={() => handleEDUIntellSchoolclick(schoolProds.MatId,schoolProds.SchoolId)} className='edu-chip' size='small'>Edu Intelligence</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 6 && (
                                                                                    <AppButton  label="Pulse"  className='lparent-chip' size='small'>Pulse</AppButton>
                                                                                )}
                                                                                </React.Fragment>
                                                                            ))
                                                                        ) : (
                                                                            <Chip label="No products available." className='learning-chip' size='small'/>                                                                      
                                                                        )}
                                                                            {/* <Chip label="Staff Wellbeing" className='staff-chip' size='small'/>
                                                                            <Chip label="Staff Insight" className='student-chip' size='small'/>
                                                                            <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                                            <Chip label="Parent Insight" className='insight-chip' size='small'/> */}
                                                                        </Stack>
                                                                    </TableCell>                                                           
                                                                    <TableCell>{detail.SchoolSubscription==null?formatDate(row.GroupDirectors[0]?.MatGroup?.Schools[0]?.SchoolSubscription?.StartDate):formatDate(detail.SchoolSubscription.StartDate)}</TableCell>
                                                                    <TableCell>{detail.SchoolSubscription==null?formatDate(row.GroupDirectors[0]?.MatGroup?.Schools[0]?.SchoolSubscription?.EndDate):formatDate(detail.SchoolSubscription.EndDate)}</TableCell>                                                                    
                                                                    <TableCell>£{(parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year1Cost) + parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year2Cost) + 
                                                                    parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year3Cost))+((parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year1Cost) + 
                                                                    parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year2Cost) + parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year3Cost))*
                                                                    (parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.VatPercentApplied)/100))}</TableCell>
                                                                    <TableCell>
                                                                    <Stack direction="row" spacing={0.5}>                                                                                                                                                        
                                                                        <AppButton onClick={() => handleSchoolDetails(detail.Id)} color={pictonBlue}>Renew</AppButton>                                                                                                                            
                                                                    </Stack>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableStyle>
                                                    </Box>
                                                </Collapse> 
                                                </TableCell>
                                            </TableRow>
                                            </React.Fragment>
                                        ))}
                                    </TableBody>                                                      
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 20, 30]}
                                    component="div"
                                    count={filteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleWelbeeChangePage}
                                    onRowsPerPageChange={handleWelbeeChangeRowsPerPage}
                                />
                            </Paper>  
                        </GroupTableStyle> 
                    </Grid>
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Grid container mt={2}>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <GroupTableStyle>                    
                            <Paper elevation={0} variant='outlined'>
                                <TableContainer>
                                    <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                            active={orderBy === 'Name'}
                                            direction={orderBy === 'Name' ? order : 'asc'}
                                            onClick={() => handleWelbeeSort('Name')}
                                            >
                                            Group Name
                                        </TableSortLabel>
                                        </TableCell>                                       
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'Products'}
                                                direction={orderBy === 'Products' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('Products')}
                                                >
                                                Products
                                            </TableSortLabel>
                                        </TableCell>                                      
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'StartDate'}
                                                direction={orderBy === 'StartDate' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('StartDate')}
                                                >
                                                Start Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'EndDate'}
                                                direction={orderBy === 'EndDate' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('EndDate')}
                                                >
                                                End Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'SubscriptionCost'}
                                                direction={orderBy === 'SubscriptionCost' ? order : 'asc'}
                                                onClick={() => handleWelbeeSort('SubscriptionCost')}
                                                >
                                                Subscription Cost
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            Action
                                        </TableCell>
                                        </TableRow>
                                    </TableHead>       
                                    <TableBody>
                                        {(sortedTestWelbeeData || [])
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => (
                                            <React.Fragment key={row.Id}>
                                             <TableRow>
                                                <TableCell>
                                                <IconButton onClick={() => handleExpand(row.Id)} disableRipple sx={{padding: '0px !important'}}>
                                                    {expandedRows.includes(row.Id) ? <ExpandLess /> : <ExpandMore />}
                                                </IconButton>
                                                </TableCell>
                                                <TableCell>{row.Name}</TableCell>                                            
                                                <TableCell>                                               
                                                    <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={0.5}>
                                                        {row.MatSchoolProductsList && (row.MatSchoolProductsList || []).length > 0 ? (
                                                            row.MatSchoolProductsList.filter((item, index, self) => 
                                                                self.findIndex((i) => i.Product === item.Product) === index
                                                            ).map((marProducts) => (
                                                                <React.Fragment key={marProducts.id}>                                                               
                                                                    {marProducts.Product === 1 && (
                                                                        // <Chip label="Main App & Toolkit" className='staff-chip' size='small'/>
                                                                        <AppButton  label="Main App & Toolkit" onClick={() => handleMatWelbeingclick(marProducts.MatId,marProducts.SchoolId,row.GroupDirectors[0].UserId)} className='staff-chip' size='small'>Main App & Toolkit</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 2 && (
                                                                        // <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                                        <AppButton  label="Student Insight" onClick={() => handleMatInsightsclick(marProducts.MatId,marProducts.SchoolId)} className='parent-chip' size='small'>Student Insight</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 3 && (
                                                                        // <Chip label="Parents Insights" className='insight-chip' size='small'/>
                                                                        <AppButton  label="Parents Insights" onClick={() => handleMatInsightsclick(marProducts.MatId,marProducts.SchoolId)} className='insight-chip' size='small'>Parents Insights</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 4 && (
                                                                        // <Chip label="Staff Insights" className='student-chip' size='small'/>
                                                                        <AppButton  label="Staff Insights" onClick={() => handleMatInsightsclick(marProducts.MatId,marProducts.SchoolId)} className='student-chip' size='small'>Staff Insights</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 5 && (
                                                                        // <Chip label="Edu Intelligence" className='staff-chip' size='small'/>
                                                                        <AppButton  label="Edu Intelligence" onClick={() => handleEDUIntellMATclick(marProducts.MatId,marProducts.SchoolId)} className='edu-chip' size='small'>Edu Intelligence</AppButton>
                                                                    )}
                                                                    {marProducts.Product === 6 && (
                                                                        <Chip label="Pulse" className='lparent-chip' size='small'/>
                                                                    )}
                                                                </React.Fragment>
                                                            ))
                                                        ) : (
                                                            <Chip label="No products available." className='learning-chip' size='small'/>
                                                        )}
                                                    </Stack>
                                                </TableCell>                                               
                                                <TableCell>{row.MatSubscription==null?'--':formatDate(row.MatSubscription.StartDate)}</TableCell>
                                                <TableCell>{row.MatSubscription==null?'--':formatDate(row.MatSubscription.EndDate)}</TableCell>                                                
                                                <TableCell>£{(parseInt(row.MatSubscription==null?0:row.MatSubscription.Year1Cost) + parseInt(row.MatSubscription==null?0:row.MatSubscription.Year2Cost) + 
                                                parseInt(row.MatSubscription==null?0:row.MatSubscription.Year3Cost))+((parseInt(row.MatSubscription==null?0:row.MatSubscription.Year1Cost) + 
                                                parseInt(row.MatSubscription==null?0:row.MatSubscription.Year2Cost) + parseInt(row.MatSubscription==null?0:row.MatSubscription.Year3Cost))*
                                                (parseInt(row.MatSubscription==null?0:row.MatSubscription.VatPercentApplied)/100))}</TableCell>
                                                <TableCell> 
                                                    <Stack direction="row" spacing={0.5}>                                                    
                                                    <AppButton  onClick={() => handleMatDetails(row.Id) } color={pictonBlue}>Renew</AppButton>                                                    
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                    <Collapse in={expandedRows.includes(row.Id)} timeout="auto" unmountOnExit>
                                                    <Box margin={1}>
                                                    <Typography variant="h6" gutterBottom component="div">
                                                        Schools
                                                    </Typography>
                                                    <TableStyle>
                                                        <Table size="small">
                                                            <TableHead>
                                                            <TableRow>
                                                                <TableCell>School Name</TableCell>                                                              
                                                                <TableCell>Products</TableCell>                                                                
                                                                <TableCell>Start Date</TableCell>
                                                                <TableCell>End Date</TableCell>
                                                                <TableCell>Subscription Cost</TableCell>
                                                                <TableCell>Action</TableCell>
                                                            </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                            {row.GroupDirectors[0]?.MatGroup?.Schools.map((detail) => (
                                                                <TableRow key={detail.Id}>
                                                                    <TableCell>{detail.Name}</TableCell>                                                                    
                                                                    <TableCell>
                                                                        <Stack direction="row" flexWrap="wrap" rowGap={0.5} columnGap={0.5}>
                                                                        {detail.schoolProductsList && detail.schoolProductsList.length > 0 ? (
                                                                            detail.schoolProductsList.filter((item, index, self) => 
                                                                            self.findIndex((i) => i.Product === item.Product) === index
                                                                            ).map((schoolProds) => (
                                                                                <React.Fragment key={schoolProds.id}>                                                                      
                                                                                {schoolProds.Product === 1 && (
                                                                                    // <Chip label="Main App & Toolkit" className='staff-chip' size='small'/>
                                                                                    <AppButton  label="Main App & Toolkit" onClick={() => handleSchoolWelbeingclick(schoolProds.MatId,schoolProds.SchoolId)} className='staff-chip' size='small'>Main App & Toolkit</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 2 && (
                                                                                    // <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                                                    <AppButton  label="Student Insight" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='parent-chip' size='small'>Student Insight</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 3 && (
                                                                                    // <Chip label="Parents Insights" className='insight-chip' size='small'/>
                                                                                    <AppButton  label="Parents Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='insight-chip' size='small'>Parents Insights</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 4 && (
                                                                                    // <Chip label="Staff Insights" className='student-chip' size='small'/>
                                                                                    <AppButton  label="Staff Insights" onClick={() => handleSchoolInsightsclick(schoolProds.MatId,schoolProds.SchoolId)} className='student-chip' size='small'>Staff Insights</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 5 && (
                                                                                    // <Chip label="Edu Intelligence" className='learning-chip' size='small'/>
                                                                                    <AppButton  label="Edu Intelligence" onClick={() => handleEDUIntellSchoolclick(schoolProds.MatId,schoolProds.SchoolId)} className='edu-chip' size='small'>Edu Intelligence</AppButton>
                                                                                )}
                                                                                {schoolProds.Product === 6 && (
                                                                                    <AppButton  label="Pulse"  className='lparent-chip' size='small'>Pulse</AppButton>
                                                                                )}
                                                                                </React.Fragment>
                                                                            ))
                                                                        ) : (
                                                                            <Chip label="No products available." className='learning-chip' size='small'/>                                                                      
                                                                        )}
                                                                            {/* <Chip label="Staff Wellbeing" className='staff-chip' size='small'/>
                                                                            <Chip label="Staff Insight" className='student-chip' size='small'/>
                                                                            <Chip label="Student Insight" className='parent-chip' size='small'/>
                                                                            <Chip label="Parent Insight" className='insight-chip' size='small'/> */}
                                                                        </Stack>
                                                                    </TableCell>                                                           
                                                                    <TableCell>{detail.SchoolSubscription==null?'--':formatDate(detail.SchoolSubscription.StartDate)}</TableCell>
                                                                    <TableCell>{detail.SchoolSubscription==null?'--':formatDate(detail.SchoolSubscription.EndDate)}</TableCell>                                                                    
                                                                    <TableCell>£{(parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year1Cost) + parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year2Cost) + 
                                                                    parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year3Cost))+((parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year1Cost) + 
                                                                    parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year2Cost) + parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.Year3Cost))*
                                                                    (parseInt(detail.SchoolSubscription==null?0:detail.SchoolSubscription.VatPercentApplied)/100))}</TableCell>
                                                                    <TableCell>
                                                                    <Stack direction="row" spacing={0.5}>                                                                                                                                                        
                                                                        <AppButton onClick={() => handleSchoolDetails(detail.Id)} color={pictonBlue}>Renew</AppButton>                                                                                                                            
                                                                    </Stack>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableStyle>
                                                    </Box>
                                                </Collapse> 
                                                </TableCell>
                                            </TableRow>
                                            </React.Fragment>
                                        ))}
                                    </TableBody>                                                      
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 20, 30]}
                                    component="div"
                                    count={filteredTestData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleWelbeeChangePage}
                                    onRowsPerPageChange={handleWelbeeChangeRowsPerPage}
                                />
                            </Paper>  
                        </GroupTableStyle> 
                    </Grid>
                </Grid>
              </CustomTabPanel>                      
            </div>
            )}
          </Box>
         </AdminTabs>       
    </AppContainer>    
  );
}

// export default withRouter(MatSubscriptionList);
export { MatSubscriptionList };